import type { ProductType } from './types';

export const ROUND_GLASS_PRODUCT_TYPES: readonly ProductType[] = [
  'single',
  'double',
  'triple',
  'mirror',
] as const;

export function supportsRoundGlass(productType: ProductType | null | undefined): boolean {
  if (!productType) return false;
  return (ROUND_GLASS_PRODUCT_TYPES as readonly string[]).includes(productType);
}
